import { render, staticRenderFns } from "./SectionDiary.vue?vue&type=template&id=1272651c&scoped=true"
import script from "./SectionDiary.vue?vue&type=script&lang=js"
export * from "./SectionDiary.vue?vue&type=script&lang=js"
import style0 from "./SectionDiary.vue?vue&type=style&index=0&id=1272651c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272651c",
  null
  
)

export default component.exports